import { render } from "./SmokeFromLightExposure.vue?vue&type=template&id=28c783e9&scoped=true&ts=true"
import script from "./SmokeFromLightExposure.vue?vue&type=script&lang=ts"
export * from "./SmokeFromLightExposure.vue?vue&type=script&lang=ts"

import "./SmokeFromLightExposure.vue?vue&type=style&index=0&id=28c783e9&scoped=true&lang=css"
import "./SmokeFromLightExposure.vue?vue&type=style&index=1&id=28c783e9&lang=css"

import exportComponent from "/data/landun/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-28c783e9"]])

export default __exports__